import round from 'lodash/round';
import { arrayOf, func } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import { CWTemplate2026 } from '../../constants';
import { quoteLineShape } from '../../prop-types';
import { COLORS } from '../../utils/constants';
import marketsWithShare from '../utils/markets-with-share';

const calculateCWShareDistribution = filteredCWTemplate => {
  const totalShares = filteredCWTemplate.reduce(
    (total, obj) => obj.countrySplit + total,
    0,
  );

  const roundedValues = filteredCWTemplate.map(template =>
    round(template.countrySplit / totalShares, 4),
  );
  // Absorb cumulative rounding error in the last entry so the sum is exactly 1.
  const sumExceptLast = roundedValues.slice(0, -1).reduce((a, b) => a + b, 0);
  roundedValues[roundedValues.length - 1] = round(1 - sumExceptLast, 4);
  return filteredCWTemplate.map((template, i) => ({
    countryCode: template.countryCode,
    countrySplit: roundedValues[i],
  }));
};

function ApplyCWTemplateButton({ quoteLines, onChangeCountrySplit }) {
  const handleClick = () => {
    quoteLines.forEach(line => {
      const lineId = line.id;
      const { countrySplit } = line;
      const availableMarkets = marketsWithShare(countrySplit);
      const filteredCWTemplate = CWTemplate2026.filter(country =>
        availableMarkets.includes(country.countryCode),
      );
      const updatedCWTemplate =
        calculateCWShareDistribution(filteredCWTemplate);

      Object.keys(countrySplit).forEach(country => {
        const CWCountrySplit = updatedCWTemplate.find(
          template => template.countryCode === country,
        );

        const value = CWCountrySplit?.countrySplit || 0;
        const targetName = `quoteLines.${lineId}.countrySplit.${country}`;
        const dataset = { quoteLineId: lineId, countryCode: country };

        onChangeCountrySplit({
          target: {
            name: targetName,
            value,
            dataset,
          },
        });
      });
    });
  };

  return (
    <Button className="mr-3" color={COLORS.PRIMARY} onClick={handleClick}>
      Apply CW 2026 Template
    </Button>
  );
}

ApplyCWTemplateButton.propTypes = {
  quoteLines: arrayOf(quoteLineShape).isRequired,
  onChangeCountrySplit: func.isRequired,
};

export default ApplyCWTemplateButton;
